import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
}

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{title}}</h4>
    </div>
    <div class="modal-body">
      <p>{{message}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="decline()">{{cancelText}}</button>
      <button type="button" class="btn btn-primary" (click)="confirm()">{{confirmText}}</button>
    </div>
  `
})
export class ConfirmDialogComponent {
  title: string = '';
  message: string = '';
  confirmText: string = 'Yes';
  cancelText: string = 'No';

  constructor(private bsModalRef: BsModalRef) {}

  confirm(): void {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden?.emit(true);
  }

  decline(): void {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden?.emit(false);
  }
}
